import { useEffect, useState } from "react";
import { FirestoreService } from "../../../../../../../api/firebase/firestoreService";
import { FirestoreDocumentReference } from "../../../../../../../api/firebase/references";
import type { QueryNode } from "../../../../../../../data-model/queryBuilder";
import type { FirstStpReviewRuleDoc } from "../../firstStpReviewRuleUtils";

function collectFields(node: QueryNode, result: Set<string>): void {
  if (node.type === "condition") {
    if (node.field) result.add(node.field);
  } else {
    for (const child of node.children) {
      collectFields(child, result);
    }
  }
}

function extractUsedFields(doc: FirstStpReviewRuleDoc): Set<string> {
  const fields = new Set<string>();
  for (const rule of doc.rules ?? []) {
    const predicate = rule.rule ?? rule.when;
    if (predicate) {
      collectFields(predicate as QueryNode, fields);
    }
  }
  return fields;
}

/**
 * Fetches the first_stp_review rules document and returns column names used in conditions.
 * These columns must not be toggled off in the Condition List.
 */
export function useQueryBuilderUsedFields(): {
  usedFields: Set<string>;
  loading: boolean;
} {
  const [usedFields, setUsedFields] = useState<Set<string>>(new Set());
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    FirestoreService.getDocument<FirstStpReviewRuleDoc>(
      FirestoreDocumentReference.pharmacyOrderUpdatesFirstStpReview(),
    )
      .then((data) => {
        if (cancelled) return;
        setUsedFields(data ? extractUsedFields(data) : new Set());
      })
      .catch(() => {
        if (!cancelled) setUsedFields(new Set());
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { usedFields, loading };
}
